import axios from '@/plugins/axios';
import enumerateArray from '@/helpers/enumerateArray';

const initialState = {
  list: [],
  currentPage: 1,
  lastPage: 1,
  perPage: 25,
};

const actions = {
  async fetchList({ commit }, params) {
    try {
      const lang = localStorage.getItem('language') || '';
      const token = localStorage.getItem('token') || '';
      const { data } = await axios.get('suppliers', {
        headers: { Authorization: `Bearer ${token}`, Lang: lang },
        params,
      });

      const suppliers = {
        ...data.data.items,
        data: enumerateArray(
          data.data.items.data,
          data.data.items.current_page,
          data.data.items.per_page,
        ),
      };

      commit('setSuppliers', suppliers);
      return data;
    } catch (error) {
      return error;
    }
  },

  async addNew(_, params) {
    try {
      const lang = localStorage.getItem('language') || '';
      const token = localStorage.getItem('token') || '';
      await axios.post('suppliers', params, {
        headers: { Authorization: `Bearer ${token}`, Lang: lang },
      });

      return { success: true };
    } catch {
      return { error: true };
    }
  },

  async updateItem(_, { id, params }) {
    try {
      const lang = localStorage.getItem('language') || '';
      const token = localStorage.getItem('token') || '';
      await axios.put(`suppliers/${id}`, params, {
        headers: { Authorization: `Bearer ${token}`, Lang: lang },
      });

      return { success: true };
    } catch {
      return { error: true };
    }
  },
};

const mutations = {
  setSuppliers(state, payload) {
    state.list = payload.data;
    state.currentPage = payload.current_page;
    state.lastPage = payload.last_page;
    state.perPage = payload.per_page;
  },
};

export default {
  namespaced: true,
  state: initialState,
  actions,
  mutations,
};
